import { Typography } from "@mui/material";
import FullScreenDialog from "components/FullScreenDialog";
import MDBox from "components/MDBox";
import FormWiclax from "./FormWiclax";
import { IResultadoCorrida } from "interfaces/resultadoCorrida";
import MDButton from "components/MDButton";

import imgWiclax from "assets/images/wiclax.webp";

interface Props {
  open: boolean;
  onClose: () => void;
  isUpdate: () => void;
  selectedEvento: IResultadoCorrida;
}
export default function ModalFullWiclax({
  open,
  onClose,
  isUpdate,
  selectedEvento,
}: Props) {
  return (
    <FullScreenDialog open={open} title="wiclax" handleClose={onClose}>
      <MDBox display="flex" justifyContent="center" my={2}>
        <MDBox width={{ xs: "95%", md: "75%" }}>
          <img src={imgWiclax} height={30} width="auto" alt="wiclax" />
          <Typography variant="subtitle1">
            Integração com seu wiclax, resultado enviado automáticamente pelo
            ftp
          </Typography>
          <Typography variant="h4">{selectedEvento?.titulo}</Typography>

          {/* Formulário para cadastrar resultado transmitido pelo wiclax */}
          <FormWiclax selectedEvento={selectedEvento} isUpdate={isUpdate} />
          {/* Cancelar fecha o modal */}
          <MDButton variant="outlined" color="info" onClick={onClose}>
            Cancelar
          </MDButton>
        </MDBox>
      </MDBox>
    </FullScreenDialog>
  );
}
